module.exports = __webpack_public_path__ + "img/topbg.557aacf1.png";